export default "fragment productFileFieldsFragment on ProductFile{\ntitle\nsrc\nversion\nextension\ncloudinary{\ncloudName\npath\n}\nsize\n}\n"